import { styled, css } from 'styled-components';

import { PreviewListItem } from '@src/components/molecules/preview-list-item';
import { Action } from 'src/components/atoms/action';

import { ActionListProps } from './types';

const mobileRoundVariantStyles = css`
  @media screen and (max-width: 1023px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    * {
      flex: 0 0 min-content;
    }

    li {
      border-top: none !important;
      width: auto;
    }
  }
`;

export const ActionListWrapper = styled.ul<{
  $isMuted: ActionListProps['isMuted'];
  $mobileVariant: ActionListProps['mobileVariant'];
}>`
  list-style: none;

  li:not(:first-child) {
    border-top: 1px solid var(--color-numa-black--200);
  }

  ${({ $isMuted }) =>
    $isMuted &&
    css`
      li:not(:first-child) {
        border-top: 1px solid rgba(0, 0, 0, 0.1);
      }
    `}

  ${Action} {
    border: none;
    width: 100%;
  }

  ${PreviewListItem} {
    @media screen and (min-width: 1024px) {
      padding-inline: 8px;
    }
  }

  ${({ $mobileVariant }) => $mobileVariant === 'round' && mobileRoundVariantStyles}
`;
